import { new__cn as cn } from '../util';

const style = {
  vVirtualScrollContainer: cn('h-full overflow-auto'),
  vVirtualScrollWrapper: cn(
    'relative',
    'box-content flex-1',
    'overflow-hidden',
  ),
  vVirtualScrollItem: cn('absolute w-fit min-w-full'),
};

export default style;
